<template>
<v-col cols="12" class="py-2">
  <v-btn-toggle :value="tableView" tile group>
    <v-btn text color="primary" value="available" v-shortkey="['alt','پ']" @shortkey="changeView('available')" @click="changeView('available')">
      موجودها(alt+M)
    </v-btn>
    <v-btn text color="primary" value="pn" v-shortkey="['alt','د']" @shortkey="changeView('pn')" @click="changeView('pn')">
      پاس نقدی ها(alt+N)
    </v-btn>
    <v-btn text color="primary" value="dv" v-shortkey="['alt','ی']" @shortkey="changeView('dv')" @click="changeView('dv')">
      درجریان وصول ها(alt+D)
    </v-btn>
    <v-btn text color="primary" value="ph" v-shortkey="['alt','ا']" @shortkey="changeView('ph')" @click="changeView('ph')">
      پاس به حسابها(alt+H)
    </v-btn>
    <v-btn text color="primary" value="bg" v-shortkey="['alt','ذ']" @shortkey="changeView('bg')" @click="changeView('bg')">
      برگشتی ها(alt+B)
    </v-btn>
    <v-btn text color="primary" value="odat" v-shortkey="['alt','خ']" @shortkey="changeView('odat')" @click="changeView('odat')">
      عودتی ها(alt+O)
    </v-btn>
    <v-btn text color="primary" value="init" v-shortkey="['alt','ش']" @shortkey="changeView('init')" @click="changeView('init')">
      اول دوره ها(alt+A)
    </v-btn>
    <v-btn text color="primary" value="all" v-shortkey="['alt','ن']" @shortkey="changeView('all')" @click="changeView('all')">
      کلیه چک ها(alt+K)
    </v-btn>
  </v-btn-toggle>
</v-col>
</template>

<script>
//
export default {
  name: 'ListButtons',
  props: ['tableView'],
  methods: {
    changeView(type) {
      this.$emit('childSetTableView', type)
    }
  },
}
</script>
